import { useAppSelector } from '@/src/redux/store'
import { getActiveStep, getCompletedSteps } from '@/src/redux/slices/itinerarySlice'
import { ItineraryStepNumberType } from '@/src/types/itinerary'

const useItineraryUtils = () => {
    const completedSteps = useAppSelector(getCompletedSteps)
    const activeStep = useAppSelector(getActiveStep)

    const getIsStepCompleted = (step: ItineraryStepNumberType) => {
        if (step < activeStep) return true
        return completedSteps.includes(step)
    }
    return {
        getIsStepCompleted
    }
}

export default useItineraryUtils
